export const isAvailable = false;

export function requestReview() {
  throw new Error('StoreReview is only available on iOS.');
}
